import Checkout from './Pages/Checkout';
// import Homepage from './Pages/Homepage';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Thankyou from './Pages/Thankyou';
import Footer from './Components/Footer';
import ReactGA from 'react-ga4';
import Home from './Pages/Home';
import HeaderNew from './Components/HeaderNew';
import BlogCollection from './Pages/BlogCollection';
import SinglePost from './Pages/SinglePost';
import Blogtags from './Pages/Blogtags';

const TRACKING_ID = "G-20X6E8MHWL"; // MEASUREMENT_ID
ReactGA.initialize(TRACKING_ID);

function App() {
  return (
    <Router >
      <HeaderNew />
      <Routes>

        <Route path="/" element={<Home />} exact />
        {/* <Route path="/home" element={<Home />} exact /> */}
        <Route path="/checkout" element={<Checkout />} exact />
        <Route path="/thankyou" element={<Thankyou />} exact />
        <Route path="/blogs" element={<BlogCollection />} exact />
        <Route path="/blogs/:slug" element={<SinglePost />} />
        <Route path="/blogs/tags/:tag" element={<Blogtags />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
